import * as React from 'react';

import * as style from './ReviewsLayout.css';

export interface IReviewsLayoutProps {
  itemsList: React.ReactElement;
  tabs: React.ReactElement;
  itemsSort: React.ReactElement;
  moreReviewsButton: React.ReactElement;
  fixedFooter: React.ReactNode;
  ratingsFilter: React.ReactElement;
  tags: React.ReactElement;
  title: React.ReactElement;
}

export const ReviewsLayout: React.FC<IReviewsLayoutProps> = props => {
  const { itemsList, itemsSort, moreReviewsButton, fixedFooter, ratingsFilter, tags, title, tabs } = props;

  return (
    <div data-testid="ReviewsLayout" className={style['container']}>
      <div className={style['column']}>
        <div className={style['header']}>
          {title}
          {itemsSort}
        </div>
        <div className={style['tags']}>{tabs}</div>
        <div className={style['tags']}>{tags}</div>
        <div className={style['reviews-list']}>{itemsList}</div>
        <div className={style['more-reviews']}>{moreReviewsButton}</div>
      </div>
      <div className={style['fixed-container']}>
        {!!fixedFooter && <div className={style['fixed-footer']}>{fixedFooter}</div>}
        <div className={style['ratings-filter']}>{ratingsFilter}</div>
      </div>
    </div>
  );
};
